import { render, staticRenderFns } from "./PhotosCreateFromCameraView.vue?vue&type=template&id=766f6c18&"
import script from "./PhotosCreateFromCameraView.vue?vue&type=script&lang=js&"
export * from "./PhotosCreateFromCameraView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports